import { homePageStyles } from "@insite/content-library/Pages/HomePage";
import { signInResetPasswordFormStyles } from "@insite/content-library/Widgets/SignIn/SignInResetPasswordForm";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

homePageStyles.page = {
    fullWidth: [true, true, true, true, true],
    css: css`
        position: relative;
        top: 128px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    position: unset;
                    top: 0px;
                `,
                css`
                    position: unset;
                    top: 0px;
                `,
                css`
                    top: 124px;
                `,
                null,
                null,
            ])}
        max-width: 100% !important;
        div[class^="GridWrapper"] {
            margin: 0px auto;
        }
        div[class^="GridOffset"] {
            max-width: 100% !important;
            margin: 0 auto;
        }
        > div[class^="Wrapper"] {
            > div[class^="GridWrapper"] {
                padding: 0px;
                > div[class^="GridOffset"] {
                    max-width: 100%;
                    > div[class^="GridItemStyle-sc"] {
                        padding: 0px;
                        > div[class^="Wrapper"] {
                            > div[class^="GridWrapper"] {
                                padding: 0px;
                                margin: 0px auto;
                            }
                        }
                    }
                }
            }
        }
    `,
};

// Other than home pages styles (Misslenious) --------------------------------------

signInResetPasswordFormStyles.cancelButton = {
    variant: "secondary",
    css: css`
        margin-right: 10px;
    `,
};
